module.exports = __webpack_public_path__ + "static/media/info-warnig.d2ab52c6.svg";